import _ from 'lodash';
import { BILLING_CYCLE } from '@/common/constants';
import { getMessageTemplateByRules } from '@/views/config/partner-refer/helper/validator';
import { mapGetters } from 'vuex';
import { translation } from '@/plugins/i18n';
import { isEmptyVal } from '@/utils';

export const editBasePlanWithPartnerMixin = {
  computed: {
    ...mapGetters(['partnerRefer', 'currentEditPlan', 'planMapFlat', 'getBoughtBasePlanInfo', 'getSelectedBasePlanInfo']),
  },
  methods: {
    getBlockCycleReason4Partner() {
      const message = getMessageTemplateByRules(this.partnerRefer?.blockBasePlanSwitchToMonthlyMsg)?.messageBody;
      const partnerName = this.partnerRefer?.partnerName;

      return {
        key: BILLING_CYCLE.MONTHLY,
        reason: message || translation('billing.partner.disabled_4_monthly', [partnerName]),
      };
    },
    getCycleDisabledKeyAndReasonForPartner() {
      // edit case (m2m/a2a/m2a/a2m)
      if (this.$context.is.edit && !isEmptyVal(this.partnerRefer)) {
        const planType = this.currentEditPlan?.type;
        const billingCycle = this.currentEditPlan?.billing_cycle;

        if (billingCycle === BILLING_CYCLE.MONTHLY) {
          const currentAnnualPlanCodes4Edit = _.chain(this.planMapFlat)
            .filter((p) => p.type === planType && p.billing_cycle === BILLING_CYCLE.ANNUAL)
            .map((p) => p.plan_code)
            .value();

          const preloadPlanCodeList = this.partnerRefer.preloadPlan || _.keys(this.partnerRefer.coupon?.discountInfo);
          const m2aCase = _.some(preloadPlanCodeList, (planCode) => {
            return _.includes(currentAnnualPlanCodes4Edit, planCode);
          });

          if (m2aCase) {
            return this.getBlockCycleReason4Partner();
          }
        }
      }

      // MIX_BUY HARDCODE FOR SWITCH TO MONTHLY
      if (this.$context.is.mixBuy) {
        return this.getBlockCycleReason4Partner();
      }

      return undefined;
    },
    // base plan upgrade cases
    getCycleDisabledReasonForPartnerWithBasePlanUpgrade() {
      // when exist base annual plan upgrade to pro plus, not allow customer to switch billing cycle to monthly
      if ((this.$context.is.pro2prop || this.$context.is.biz2bundle) && !isEmptyVal(this.partnerRefer)) {
        const moreThanMonthly = _.some(this.getBoughtBasePlanInfo?.plans, (p) => p?.cycleValue > 1);
        const promoMoreThanMonthly = _.some(this.getSelectedBasePlanInfo?.plans, (p) => p?.cycleValue > 1);
        return (moreThanMonthly && promoMoreThanMonthly) ? this.getBlockCycleReason4Partner() : undefined;
      }

      return undefined;
    },
  },
};
